import React, { PureComponent } from 'react';

import strings from 'app/locales/full-analysis';

import bask from 'app/images/bask.jpg';
import manChild from 'app/images/man-child.jpg';
import player from 'app/images/player.jpg';
import robot from 'app/images/robot.jpg';
import classic from 'app/images/classic.jpg';

import Banner from 'app/components/Banner';
import Intro from 'app/components/Intro';
import ContentSection from 'app/components/ContentSection';

import styles from './styles.css';

class FullAnalysis extends PureComponent {
  render() {
    const { banner, copyBlockOne, intro } = strings;

    return (
      <div className={styles.container}>
        <Banner text={banner} className={styles.banner} />
        <Intro {...intro} hasLightBg={true} />
        <div className={styles.restContainer}>
          <div className={styles.types}>
            <span className={styles.type}>
              <img src={manChild} alt="Man baby" />
              <p className={styles.typeTitle}>Man baby</p>
            </span>
            <span className={styles.type}>
              <img src={player} alt="player" />
              <p className={styles.typeTitle}>Player</p>
            </span>
            <span className={styles.type}>
              <img src={robot} alt="robot" />
              <p className={styles.typeTitle}>Robot</p>
            </span>
            <span className={styles.type}>
              <img src={classic} alt="classic" />
              <p className={styles.typeTitle}>Classic prick</p>
            </span>
          </div>
          <div className={styles.largeImage}>
            <img src={bask} alt="BASK" />
          </div>
          <div className={styles.keys}>
            <span className={styles.key}>
              <p className={styles.keyTitle}>Balanced</p>
              <span className={styles.keyCircleBlue} />
            </span>
            <span className={styles.key}>
              <p className={styles.keyTitle}>Availability</p>
              <span className={styles.keyCircleBlueDark} />
            </span>
            <span className={styles.key}>
              <p className={styles.keyTitle}>Stability</p>
              <span className={styles.keyCircleBlueGreen} />
            </span>
            <span className={styles.key}>
              <p className={styles.keyTitle}>Kindness</p>
              <span className={styles.keyCircleBlueLight} />
            </span>
          </div>
        </div>
        <ContentSection {...copyBlockOne} />
      </div>
    );
  }
}

export default FullAnalysis;



// WEBPACK FOOTER //
// ./src/routes/FullAnalysis/index.js